import Grid from '@material-ui/core/Grid';
import withWidth from '@material-ui/core/withWidth';
import React, { Component } from 'react';

import { MyTableContext } from '..';
import styles from '../styles';

interface IProps {
  onDoubleClick?: any;
  onClick?: any;
  hover?: any;
  style?: any;
  width?: any;
  className?: any;
  responsive?: boolean;
  classes?: any;
}

class MyTableRow extends Component<IProps, any> {
  componentDidMount() {
    let viewportW = window.innerWidth;
    let device;

    if (viewportW <= 320) {
      device = 'mobile';
    } else if (viewportW > 320 && viewportW <= 960) {
      device = 'tablet';
    } else {
      device = 'desktop';
    }

    this.setState({
      device,
    });
  }

  render() {
    const { classes, width, responsive, className } = this.props;

    if (!responsive || width === 'md' || width === 'lg' || width === 'xl') {
      return (
        <tr onDoubleClick={this.props.onDoubleClick} onClick={this.props.onClick} className={`${classes.tRow} ${className || ''}`}>
          {this.props.children}
        </tr>
      );
    }

    return (
      <Grid
        onClick={this.props.onClick}
        onDoubleClick={this.props.onDoubleClick}
        container={true}
        justify='flex-start'
        className={`${classes.tdCardRow} ${className}`}
      >
        {this.props.children}
      </Grid>
    );
  }
}

export default withWidth()(
  styles(
    React.forwardRef((props: IProps, ref: any) => (
      <MyTableContext.Consumer>{(context) => <MyTableRow {...props} {...context} ref={ref} />}</MyTableContext.Consumer>
    ))
  )
);
